const CadastroPreUsuario = () => import('../../spa/pre-usuario/CadastroPreUsuario');

export default {
  path: 'pre-usuario',
  name: 'pre-usuario',
  component: CadastroPreUsuario,
};
